import { Injectable } from "@angular/core";
import { map, tap } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { NdmsAuthService } from "./ndms-auth.service";
import { Observable } from "rxjs";
import { IdentityAccountModel } from "../models/identity-account.model";
import { LookupService } from "../../../../../projects/shared/core/services/lookup.service";
import { UserService } from "../../../../../projects/shared/core/app/api/services/user.service";

@Injectable({
  providedIn: 'root',
})
export class IdentityAccountsService {
  private _endpointUrl = '/api/accounts';
  private authorized: boolean = false;
  public pagingData: any = {
    Page: 1,
    totalCount: 0
  };

  constructor(private _http: HttpClient,
    private _authApiService: NdmsAuthService,
    private _lookupService: LookupService,
    private _userService: UserService
  ) { }

  GetCurrentUser(): Observable<any> {
    let url = this._authApiService.identityUrl + this._endpointUrl + '/GetCurrent';
    let options = this._authApiService.getOptions(this._authApiService.getServerToken());

    return this._http.get(url, options).pipe();
  }

  GetUserById(id: string): Observable<any> {
    let url = this._authApiService.identityUrl + this._endpointUrl + '/' + id;
    let options = this._authApiService.getOptions(this._authApiService.getServerToken());

    return this._http.get(url, options).pipe();
  }

  Query(filter: any): Observable<any> {
    let url = this._authApiService.identityUrl + this._endpointUrl;
    let options = this._authApiService.getOptions(this._authApiService.getServerToken());
    options.params = { email: encodeURIComponent(filter.email) };
    return this._http.get(url, options).pipe(map((r: any) => {
      var applications = r.lookups['applications'];
      this._lookupService.set('applications', applications);
      this.pagingData.totalCount = r.pagingData!.totalCount;
      return r;
    }));
  }

  upload(userList) {
    return this._userService.Upload(userList).pipe(tap());
  }

  Save(identityAccount: IdentityAccountModel, id: string): Observable<any> {
    let url = this._authApiService.identityUrl + this._endpointUrl + '/' + id;
    let options = this._authApiService.getOptions(this._authApiService.getServerToken());

    return this._http.post(url, identityAccount, options).pipe();
  }

  ResetPassword(id: string): Observable<any> {
    let url = this._authApiService.identityUrl + this._endpointUrl + '/' + id + '/reset-password';
    let options = this._authApiService.getOptions(this._authApiService.getServerToken());

    return this._http.post(url, {}, options).pipe();
  }

  Reset2FA(id: string): Observable<any> {
    let url = this._authApiService.identityUrl + this._endpointUrl + '/' + id + '/reset-two-factor';
    let options = this._authApiService.getOptions(this._authApiService.getServerToken());

    return this._http.post(url, {}, options).pipe();
  }

  SendInvitation(identityAccount: IdentityAccountModel): Observable<any> {
    let url = this._authApiService.identityUrl + this._endpointUrl + '/invite';
    let options = this._authApiService.getOptions(this._authApiService.getServerToken());

    return this._http.post(url, identityAccount, options).pipe();
  }

  Unlock(userId: string): Observable<any> {
    let unlockUrl = this._authApiService.identityUrl + this._endpointUrl + '/' + userId + '/Unlock';
    let options = this._authApiService.getOptions(this._authApiService.getServerToken());

    return this._http.post(unlockUrl, {}, options).pipe();
  }

  AddUserToRoles(userId: string, roles: string[]): Observable<any> {
    let addRolesUrl = this._authApiService.identityUrl + this._endpointUrl + '/' + userId + '/AddRoles';
    let options = this._authApiService.getOptions(this._authApiService.getServerToken());

    return this._http.post(addRolesUrl, roles, options).pipe();
  }

  RemoveUserFromRoles(userId: string, roles: string[]): Observable<any> {
    let removeRolesUrl = this._authApiService.identityUrl + this._endpointUrl + '/' + userId + '/RemoveRoles';
    let options = this._authApiService.getOptions(this._authApiService.getServerToken());

    return this._http.post(removeRolesUrl, roles, options).pipe();
  }
}
